import styled from '../theme';
import * as React from 'react';
import { IRegistrationSubmission } from '../App'

import Title from './TitleComponent';
import SubText from './SubTextComponent';
import LanguageSwitcher from './LanguageSwitcher';
import EmailInput from './Inputs/EmailInput';
import NameInput from './Inputs/NameInput';
import PostcodeInput from './Inputs/PostcodeInput';
import { recaptchaKey } from '../lib/config';
import ReCAPTCHA from 'react-google-recaptcha';
import { StyledCityGeoSuggest } from './Inputs/CityInput';
import { Suggest } from 'react-geosuggest';
import CountrySuggestionInput from './Inputs/CountrySuggestionInput';
interface IRegFormFields {
    title: string
    subHeading: string
    localeEnglishLabel: string
    localeSimplifiedChineseLabel: string
    nameInputLabel: string
    nameInputError: string
    emailInputLabel: string
    emailInputError: string
    countryInputLabel: string
    countryInputError: string
    cityInputLabel: string
    cityInputError: string
    postcodeInputLabel: string
    postcodeInputError: string
    subscriptionMessage: string
    formSubmitLabel: string
    conditionsMessage: string
}

interface IRegFormProps {
    centreID?: string
    locale: string
    language: string
    content: IRegFormFields
    source: string
    hideQRCode?: boolean
    changeLocale(e: any): void
    submitRegistration(payload: IRegistrationSubmission): void
}

interface IRegFormState {
    centreID: string;
    countryInformation: any;
    cityInformation: any;
    email: string;
    marketingOptIn: boolean;
    postcode: string;
    fullname: string;
    url: string;
    buttonDisabled: boolean;
    fullnameValid: boolean;
    emailValid: boolean;
    countryValid: boolean;
    additionalValid: boolean;
    hasCityContent: boolean;
    hasCityFocus: boolean;
}

const recaptchaRef = React.createRef<ReCAPTCHA>();

class RegistrationForm extends React.Component<IRegFormProps, IRegFormState> {

    constructor(props: IRegFormProps) {
        super(props);
        this.state = {
            centreID: 'vic-chadstone',
            countryInformation: null,
            cityInformation: null,
            email: '',
            marketingOptIn: false,
            postcode: '',
            fullname: '',
            url: '',
            buttonDisabled: true,
            fullnameValid: false,
            emailValid: false,
            countryValid: false,
            additionalValid: false,
            hasCityContent: false,
            hasCityFocus: false
        }

        this.registerUser = this.registerUser.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.onCitySelect = this.onCitySelect.bind(this);
        this.renderExtra = this.renderExtra.bind(this);
        this.validateAllInputs = this.validateAllInputs.bind(this);
        this.checkAllInputs = this.checkAllInputs.bind(this)
        this.setFullname = this.setFullname.bind(this);
        this.setPostcode = this.setPostcode.bind(this);
        this.setEmail = this.setEmail.bind(this);
        this.countryChanged = this.countryChanged.bind(this);
        this.handleCityFocus = this.handleCityFocus.bind(this);
        this.handleCityBlur = this.handleCityBlur.bind(this);
        this.cityChanged = this.cityChanged.bind(this);
        this.countryRegInputValue = this.countryRegInputValue.bind(this)
    }
    
    public countryRegInputValue = (inputValue: string) => {
      this.setState({
        countryInformation: {countryCode: inputValue},
        cityInformation: null,
        postcode: ''
    }, () => {
        this.validateAllInputs('country', true);
        this.validateAllInputs('additional', false);
    })
    }
    public handleCityFocus() {
      this.setState({hasCityFocus: true})
    }
    public handleCityBlur() {
      this.setState({hasCityFocus: false})
    }
    public validateAllInputs(inputID: string, isCorrect: boolean): any {
        if (inputID === 'email') {
            this.setState({
                emailValid: isCorrect
            }, () => {
                this.checkAllInputs(this.state)
            })
        }
        if (inputID === 'name') {
            this.setState({
                fullnameValid: isCorrect
            }, () => {
                this.checkAllInputs(this.state)
            })
        }
        if (inputID === 'country') {
            this.setState({
                countryValid: isCorrect
            }, () => {
                this.checkAllInputs(this.state)
            })
        }
        if (inputID === 'additional') {
            this.setState({
                additionalValid: isCorrect
            }, () => {
                this.checkAllInputs(this.state)
            })
        }
    }

    public checkAllInputs(state: any): any {
        this.setState({
            buttonDisabled: !(state.emailValid &&
                state.fullnameValid &&
                state.countryValid
                &&
                state.additionalValid)
        })
    }


    public registerUser(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();

        const submissionInformation: IRegistrationSubmission = {
            fullname: this.state.fullname,
            email: this.state.email,
            locale: this.props.locale,
            subscription_opt_in: this.state.marketingOptIn,
            countryCode: '',
            hideQRCode: this.props.hideQRCode,
            source: this.props.source,
            recaptchaValue: recaptchaRef.current ? recaptchaRef.current.getValue() || '' : ''
        }

        if (this.state.countryInformation) {
            submissionInformation.countryCode = this.state.countryInformation.countryCode
        }

        if (this.state.postcode) {
            submissionInformation.postcode = this.state.postcode
        }
        if (this.state.cityInformation) {
            submissionInformation.city = this.state.cityInformation.name
        }
        
        this.props.submitRegistration(submissionInformation)
    }

    public toggleCheckbox(): void {
        this.setState({
            marketingOptIn: !this.state.marketingOptIn
        })
    }

    public countryChanged(value: string) {
      if (this.state.countryInformation) {
        this.setState({
            countryInformation: null
        })

        this.validateAllInputs('country', false);
    }
    if (this.state.hasCityContent) {
        this.setState({hasCityContent:  false})
      }
      if (this.state.hasCityFocus) {
        this.setState({hasCityFocus:  false})
      }
  }

    public onCitySelect(selection: Suggest) {
        if (selection) {
          this.setState({
              cityInformation: {name: selection.label},
              hasCityFocus: false
          }, () => {
              this.validateAllInputs('additional', true)
          })
      }
    }
    public cityChanged(value: string) {
      if (!this.state.hasCityContent && value) {
        this.setState({hasCityContent:  true})
      } else {
        if (!value) {
          this.setState({hasCityContent:  false})
        }
      }
      if (this.state.cityInformation) {
        this.setState({
            cityInformation: null
        })

        this.validateAllInputs('additional', false);
    }
  }
    public renderExtra(countryInformation: any): any {
        if (countryInformation === null) {
            return null
        }

        if (countryInformation.countryCode === 'au') {
            return (
                <PostcodeInput
                    content={this.props.content}
                    validateInput={this.validateAllInputs}
                    onValueChange={this.setPostcode}
                />
            )

        } else {
            return (
              <div style={{position: 'relative', width: '100%'}}>
                <CityLabel className={[(this.state.hasCityContent ? 'hasCityContent' : ''),
                    (this.state.hasCityFocus ? 'focused' : '')].join(' ')}>{this.props.content.cityInputLabel}</CityLabel>
                <StyledCityGeoSuggest 
                    placeholder={''}
                    onSuggestSelect={this.onCitySelect}
                    country={this.state.countryInformation && this.state.countryInformation.countryCode }
                    types={['(cities)']}
                    onFocus={this.handleCityFocus}
                    onBlur={this.handleCityBlur}
                    onChange={this.cityChanged}
                    inputClassName={[(this.state.hasCityContent ? 'hasContent' : ''),
                        (this.state.hasCityFocus ? 'focused' : '')].join(' ')}
                    queryDelay={0}
                  />
              </div>
            )
        }
    }

    public setFullname(fullname: string): void {
        this.setState({
            fullname: fullname
        });
    }

    public setPostcode(postcode: string): void {
        this.setState({
            postcode: postcode
        });
    }

    public setEmail(email: string): void {
        this.setState({
            email: email
        });
    }


    public render() {
        if (this.props.content === null) {
            return null
        }
        
        return (
            <Wrapper >
                <LanguageSwitcher
                    locale={this.props.locale}
                    content={this.props.content}
                    changeLocale={this.props.changeLocale}
                />
                <Title content={this.props.content.title} />
                <SubText content={this.props.content.subHeading} />

                <FormWrapper onSubmit={this.registerUser} id="reg-form">

                    <NameInput
                        content={this.props.content}
                        validateInput={this.validateAllInputs}
                        onValueChange={this.setFullname}
                    />

                    <EmailInput
                        content={this.props.content}
                        validateInput={this.validateAllInputs}
                        onValueChange={this.setEmail}
                    />

                    <CountrySuggestionInput
                      id="CountryInput"
                      content={this.props.content}
                      validateInput={this.validateAllInputs}
                      onValueChange={this.countryChanged}
                      countryInputValue={this.countryRegInputValue}
                    />
                    
                    {this.renderExtra(this.state.countryInformation)}

                    <MarketingWrapper>
                        <CheckBox>
                            <input id="marketingOptIn" type="checkbox" checked={this.state.marketingOptIn} onChange={this.toggleCheckbox} />
                            <label htmlFor="marketingOptIn" />
                        </CheckBox>
                        <MarketingMessage onClick={this.toggleCheckbox}>{this.props.content.subscriptionMessage} </MarketingMessage>
                    </MarketingWrapper>

                    <ConditionsMessage dangerouslySetInnerHTML={{ __html: this.props.content.conditionsMessage }} />


                    { (recaptchaKey && recaptchaKey !== '') &&
                        <div style={{margin: '30px 0 10px 0'}}>
                            <ReCAPTCHA ref={recaptchaRef} sitekey={recaptchaKey}/>
                        </div>
                    }

                    <SubmitButton disabled={this.state.buttonDisabled}>{this.props.content.formSubmitLabel}</SubmitButton>
                </FormWrapper >
            </Wrapper >
        )
    }
}

export default RegistrationForm

const Wrapper = styled.div`
  * {
     box-sizing: border-box;
  }
    width: 500px;
    display: flex;
    flex-direction: column;

    @media (max-width: 550px) {
        width: 100%;
    }
    .hasContent  {
      padding-top: 18px !important;
      padding-bottom: 0 !important;
    }
`

const SubmitButton = styled.button`
    width: 100%;
    height: 60px;
    margin: 10px 0;
    background: ${(props: any) => props.theme.colors.backgroundHighlight};
    color: ${(props: any) => props.theme.colors.bodyHighlight};
    border: none;
    border-radius: 5px;
    font-weight: 800;

    &:disabled {
        opacity: 0.5;
    }
`
const MarketingWrapper = styled.div`
    margin: 30px 10px;
    display: flex;
    width: 100%;
`
const FormWrapper = styled.form`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 20px;
    position: relative;
    
`

const CityLabel = styled.label`
  z-index: 10;
  position: absolute;
  top: 30px;
  left: 18px;
  color: ${(props: any) => props.theme.colors.bodyLight}; 
  font-weight: 400;
  font-size: 0.9em;
  pointer-events: none;
  &.hasCityContent {
    font-size: 0.7em;
    top: 20px;
    color: ${(props: any) => props.theme.colors.bodyLight}
  }
  &.focused {
    color: ${(props: any) => props.theme.colors.backgroundHighlight}
  }
`
const CheckBox = styled.div`
    width: 15px;
    position: relative;
    margin-left: 15px;

    label {
        width: 15px;
        height: 15px;
        cursor: pointer;
        position: absolute;
        top: 0;
        left: 0;
        background: #fcfff4;
        border-radius: 4px;
        &:after {
            content: '';
            width: 8px;
            height: 5px;
            position: absolute;
            top: 2px;
            left: 2px;
            border: 3px solid #333;
            border-top: none;
            border-right: none;
            background: transparent;
            opacity: 0;
            transform: rotate(-45deg);
        }
    }

    input[type=checkbox] {
        visibility: hidden;
        &:checked + label:after {
            opacity: 1;
        }
    }    
`

const MarketingMessage = styled.h3`
    margin: 0 auto;
    width: 100%;
    padding-left: 10px;
    font-weight: 200;
    font-size: 1em;
    line-height: 1.2;
    color: ${(props: any) => props.theme.colors.bodyLight};
`

const ConditionsMessage = styled(MarketingMessage)`
    font-size: 0.8em;
    padding-left: 0;
    text-align: center;
    a {
        color: ${(props: any) => props.theme.colors.bodyLight};
    }
`



// WEBPACK FOOTER //
// ./src/components/RegistrationForm.tsx